$.validator.addMethod('account-format', function(value) {
    let regEx = new RegExp("^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\\])$", 'gmi');

    return value.match(regEx) !== null;
});

$.validator.addMethod('password-format', function(value) {
    return value.length >= 8 && /^(?=.*[0-9])(?=.*[a-zA-Z])([a-zA-Z0-9~#@$%&!*_?^\-<>]+)$/.test(value) !== false;
});

$.validator.addMethod('account-used', function(value) {
    let account = value.trim();
    if (!$.validator.accountUsedCache) {
        $.validator.accountUsedCache = { lastValue: '', lastResult: true };
    }
    const cache = $.validator.accountUsedCache;
    if (cache.lastValue === account) {
        return cache.lastResult;
    }

    let flag = 1;
    let apiUrlParam = userAvailabilityUrl.replace('{account}', account);
    let apiUrl = `${coreUrl}${apiUrlParam}`;

    $.ajax({
        url: apiUrl,
        method: 'get',
        dataType: 'json',
        async: false
    }).done(function(response) {
        if (response.data.is_available === false) {
            flag = 0;
        } else {
            $('#account-checked').show();
        }
    })

    cache.lastValue = account;
    cache.lastResult = flag !== 0;
    return cache.lastResult;
});
